import axios from 'axios'

var fetch = axios.create({
    baseURL:process.env.VUE_APP_BASEURL,
    // withCredentials : false,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    timeout: 20000,
})


fetch.interceptors.response.use(function (res) {
    if (res.data && res.data.code === 'success') {
        return Promise.resolve(res.data);
    } else {
        if (res.data && res.data.code && res.data.code == 20003) {
        }
        return Promise.reject(res.data.message);
    }
    ;
}, function (error) {
    console.log(error);
    return Promise.reject({
        message: error.message
    });
});


export default fetch;
